import React from 'react'

const Footer = () => {
  return (
    <div className='bg-[#00957C] h-24 m-w-[1240px] text-black'>
      <h5 className='text-center pt-8 font-bold'>&copy; Krusty's Crypto Tracker 2022</h5>
    </div>
  )
}

export default Footer